import { create } from "zustand"
import type { TAddDualCategoryStore } from "types/configuration.type"

export const useAddDualPartCategoryStore = create<TAddDualCategoryStore>((set) => ({
	category: {
		name: "",
		label: "",
		topLevelCategory: "",
		superCategory: "",
		rightModelNumbers: [],
		leftModelNumbers: [],
		wholeModelNumbers: [],
	},

	setLeftModelNumbers: (modelNumbers: number[]) =>
		set((state) => ({
			category: { ...state.category, leftModelNumbers: modelNumbers },
		})),

	setRightModelNumbers: (modelNumbers: number[]) =>
		set((state) => ({
			category: { ...state.category, rightModelNumbers: modelNumbers },
		})),

	setWholeModelNumbers: (modelNumbers: number[]) =>
		set((state) => ({
			category: { ...state.category, wholeModelNumbers: modelNumbers },
		})),

	setFormValues: ({ name, label, topLevelCategory, superCategory }) =>
		set((state) => ({
			category: {
				...state.category,
				name,
				label,
				topLevelCategory,
				superCategory,
			},
		})),

	resetForm: () =>
		set(() => ({
			category: {
				name: "",
				label: "",
				topLevelCategory: "",
				superCategory: "",
				rightModelNumbers: [],
				leftModelNumbers: [],
				wholeModelNumbers: [],
			},
		})),
}))
